// channelNamespace = 0 = ott channels

import { getBaseUrl, getSessionTicket } from '../../config';
import { getDataFromResponse } from '../../controllers/Fetch';
import { Api, Channel } from '../../interfaces';
import { getAuth } from '../../utils/auth-utils';
import { constructChannel } from './utils';

// channelNamespace = 4000 = ott channels and iptv channels
export async function getChannels(channelNamespace = '0') {
  const res = await fetch(getBaseUrl() + '/EPG/JSON/AllChannel', {
    method: 'POST',
    headers: { SessionTicket: getSessionTicket() },
    body: JSON.stringify({
      domain: 0,
      metaDataVer: 'Channel/1.1',
      filterlist: [{ key: 'IsHide', value: '-1' }],
      properties: [
        {
          include: [
            '/channellist/logicalChannel/contentId',
            '/channellist/logicalChannel/name',
            '/channellist/logicalChannel/chanNo',
            '/channellist/logicalChannel/mediaid',
            '/channellist/logicalChannel/locationCopyrights',
            '/channellist/logicalChannel/pictures/picture/href',
            '/channellist/logicalChannel/physicalChannels/physicalChannel/extensionInfo',
            '/channellist/logicalChannel/physicalChannels/physicalChannel/mediaId',
            '/channellist/logicalChannel/physicalChannels/physicalChannel/btvBR/is',
            '/channellist/logicalChannel/physicalChannels/physicalChannel/btvBR/va',
            '/channellist/logicalChannel/physicalChannels/physicalChannel/videoCodec',
            '/channellist/logicalChannel/physicalChannels/physicalChannel/cutvCR',
            '/channellist/logicalChannel/physicalChannels/physicalChannel/npvrRecCR',
          ].join(),
        },
      ],
    }),
  });

  const data = await getDataFromResponse<Api.ChannelsResponse>(res);

  return data.channellist.map(constructChannel);
}

function lockFreeToAirChannels(channels: Channel[]) {
  const { isGuest, isInternetOnly } = getAuth();

  if (isGuest && !isInternetOnly) {
    return channels.map((channel: Channel) => {
      return {
        ...channel,
        channelPermissions: {
          ...channel.channelPermissions,
          notInSubscription: true,
        },
      };
    });
  } else {
    return channels;
  }
}

export async function getChannelsIncludingIPTV() {
  const [iptvChannels, ottChannels] = await Promise.allSettled([getChannels('4000'), getChannels('0')]);

  if (iptvChannels.status === 'rejected' && ottChannels.status === 'fulfilled') {
    return lockFreeToAirChannels(ottChannels.value);
  }

  if (iptvChannels.status === 'fulfilled' && ottChannels.status === 'rejected') {
    return lockFreeToAirChannels(iptvChannels.value);
  }

  if (iptvChannels.status === 'fulfilled' && ottChannels.status === 'fulfilled') {
    const mergedList = [...iptvChannels.value];
    ottChannels.value.forEach((ottChannel) => {
      const foundIPTVChannelIndex = mergedList.findIndex((x) => x.contentId === ottChannel.contentId);
      if (foundIPTVChannelIndex !== -1) {
        mergedList[foundIPTVChannelIndex] = ottChannel;
      } else {
        mergedList.push(ottChannel);
      }
    });
    return lockFreeToAirChannels(mergedList);
  }

  throw new Error('Could not fetch channels');
}
